module.exports = __webpack_public_path__ + "assets/coupon.4cee0a47.svg";